import { type BreadcrumbItem } from 'components/ui';

export const getBreadcrumbTitle = (items?: BreadcrumbItem[], loading?: boolean) =>
  items
    ?.map(i => i.title?.toString().trim())
    .filter(t => t && !(loading && t.includes('undefined')))
    .join(' / ') || undefined;
